import {ACTION_TYPE} from "utils/constants";

export const toggleComponent = component => ({
  type: ACTION_TYPE.TOGGLE_COMPONENT,
  payload: {component},
});

export const changeCurrentPropertyTab = tab => ({
  type: ACTION_TYPE.CHANGE_CURRENT_PROPERTY_TAB,
  payload: tab,
});
